import styled from 'styled-components';

export const CommunicationPreferencesHeader = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
